import { z } from "zod";
import {
  Fulfillment,
  FulfillmentDtoSchema,
  fulfillmentFromDto,
  FulfillmentSchema,
} from "./fulfillment";
import { apiListSchema } from "./list";
import {
  ReservationServiceDtoSchema,
  reservationServiceFromDto,
  ReservationServiceSchema,
  reservationServiceToDto,
} from "./reservation-service";

//? DTO
export const ReservationServiceWithfulfillmentsDtoSchema =
  ReservationServiceDtoSchema.extend({
    Balance: z.number().nullish(),
    IsPayed: z.boolean().nullish(),
    FulfillmentReservationServices: z
      .array(
        z.object({
          FulfillmentId: z.number(),
          ReservationServiceId: z.number(),
          Fulfillment: FulfillmentDtoSchema.nullish(),
        }),
      )
      .nullish(),
  });
export type ReservationServiceWithfulfillmentsDto = z.infer<
  typeof ReservationServiceWithfulfillmentsDtoSchema
>;
export const ReservationServicesWithFulFillmentsDtoListSchema = apiListSchema(
  ReservationServiceWithfulfillmentsDtoSchema,
);
//? Model

export const ReservationServiceWithFulfillmentsSchema =
  ReservationServiceSchema.extend({
    fulfillments: z.array(FulfillmentSchema),
    balance: z.number().nullish(),
    isPayed: z.boolean().nullish(),
  });

export type ReservationServiceWithFulfillments = z.infer<
  typeof ReservationServiceWithFulfillmentsSchema
>;
//? Mappers
export function reservationServiceWithFulfillmentsFromDto(
  dto: ReservationServiceWithfulfillmentsDto,
): ReservationServiceWithFulfillments {
  return {
    ...reservationServiceFromDto(dto),
    fulfillments:
      (dto.FulfillmentReservationServices?.map((f) =>
        f.Fulfillment ? fulfillmentFromDto(f.Fulfillment) : undefined,
      ).filter(Boolean) as Fulfillment[]) ?? [],
    balance: dto.Balance,
    isPayed: dto.IsPayed,
  };
}

export function reservationServiceWithFulfillmentsToDto(
  model: ReservationServiceWithFulfillments,
): ReservationServiceWithfulfillmentsDto {
  return {
    ...reservationServiceToDto(model),
    Balance: undefined as unknown as number,
    IsPayed: undefined as unknown as boolean,
    FulfillmentReservationServices: model.fulfillments.map((f) => {
      return {
        FulfillmentId: Number.parseInt(f.id),
        ReservationServiceId: Number.parseInt(model.id),
        Fulfillment: undefined,
      };
    }),
  };
}
